<template>
    <empty-message type="bug" class="network-error">
        <template #title>We cannot connect to the CLI!</template>
        <template #content>
            <p>
                Please ensure you have the CLI installed. Once you do you can run the following in a terminal to get
                sandbox mode up and running:
            </p>
            <pre>
                <code>cd /path/to/banner</code>
                <code>{{ command }}</code>
            </pre>
            <p><router-link :to="{ name: AppRouteNames.SANDBOX }">Click here to try again</router-link></p>
        </template>
    </empty-message>
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";

import EmptyMessage from "@/components/common/EmptyMessage.vue";
import config, { LOCAL_URL, PROD_URL } from "@/config/index";
import { AppRouteNames } from "@/router/constants";

const router = useRouter();
const cliUri = config.getHoxtonCliUri();
const command = ref("hoxton");

onMounted(() => {
    switch (cliUri) {
        case LOCAL_URL:
            command.value = "hoxton --local";
            break;
        case PROD_URL:
            command.value = "hoxton";
            break;
    }
});

function checkServerConnection() {
    setTimeout(() => {
        void (async () => {
            try {
                // This will only error if the server is unreachable
                await fetch(config.getHoxtonCliUri());
                // If there is no error then we can switch back to the sandbox
                await router.push({ name: AppRouteNames.SANDBOX });
            } catch {
                checkServerConnection();
            }
        })();
    }, 5000);
}

checkServerConnection();
</script>

<style lang="scss" scoped>
@use "@style/variables" as *;

.network-error {
    margin: 50px auto;
    text-align: center;

    p {
        margin: 10px 0;
    }
}

pre {
    white-space: normal;
    background: rgba($color: #000000, $alpha: 0.8);
    padding: $spacing-base;
    display: inline-block;
    border-radius: $border-radius-larger;
    box-shadow: $box-shadow-base;

    code {
        display: block;
        text-align: left;
        color: white;
        border-radius: 5px;
        white-space: normal;

        &:before {
            content: "$ ";
        }
    }
}
</style>
